(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var root = document.querySelector("[data-contact-root]");
    if (!root) return;

    var form = document.getElementById("unisource-contact-form");
    var button = document.getElementById("contact-submit");
    var alertBox = document.getElementById("contact-alert");
    var success = document.getElementById("contact-success");
    var reference = document.getElementById("contact-reference");
    var again = document.getElementById("contact-another");
    var message = document.getElementById("contact-message");
    var count = document.getElementById("contact-message-count");

    var submitUrl =
      root.getAttribute("data-submit-url") ||
      "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/forms/submit";

    var isSubmitting = false;

    if (!form) return;

    if (form.dataset.contactSubmitBound === "true") return;
    form.dataset.contactSubmitBound = "true";

    function getField(name) {
      return form.querySelector('[name="' + name + '"]');
    }

    function getValue(name) {
      var field = getField(name);
      return field ? String(field.value || "").trim() : "";
    }

    function getPreferredContactMethod() {
      var checked = form.querySelector('input[name="preferredContactMethod"]:checked');
      return checked ? checked.value : "";
    }

    function getConsentChecked() {
      var consent = form.querySelector('input[name="consent"]');
      return !!(consent && consent.checked);
    }

    function getErrorEl(name) {
      return root.querySelector('[data-error-for="' + name + '"]');
    }

    function setError(name, messageText) {
      var field = getField(name);
      var error = getErrorEl(name);

      if (error) error.textContent = messageText || "";

      if (field) {
        if (messageText) field.setAttribute("aria-invalid", "true");
        else field.removeAttribute("aria-invalid");
      }
    }

    function clearErrors() {
      [
        "name",
        "organization",
        "email",
        "phone",
        "inquiryType",
        "preferredContactMethod",
        "message",
        "consent"
      ].forEach(function (name) {
        setError(name, "");
      });

      if (alertBox) {
        alertBox.hidden = true;
        alertBox.textContent = "";
      }
    }

    function showAlert(messageText) {
      if (!alertBox) return;
      alertBox.textContent = messageText;
      alertBox.hidden = false;
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function validate() {
      clearErrors();
      var valid = true;
      var name = getValue("name");
      var email = getValue("email");
      var phone = getValue("phone");
      var inquiryType = getValue("inquiryType");
      var preferredContactMethod = getPreferredContactMethod();
      var messageValue = getValue("message");
      var consentChecked = getConsentChecked();

      if (!name) { setError("name", "Please enter your name."); valid = false; }
      if (!email) { setError("email", "Please enter your email."); valid = false; }
      else if (!isValidEmail(email)) { setError("email", "Please enter a valid email address."); valid = false; }
      if (!phone) { setError("phone", "Please enter your phone number."); valid = false; }
      if (!inquiryType) { setError("inquiryType", "Please select an inquiry type."); valid = false; }
      if (!preferredContactMethod) { setError("preferredContactMethod", "Please select a preferred contact method."); valid = false; }
      if (!messageValue) { setError("message", "Please enter your message."); valid = false; }
      else if (messageValue.length < 10) { setError("message", "Please enter at least 10 characters."); valid = false; }
      if (!consentChecked) { setError("consent", "Please confirm your consent."); valid = false; }

      if (!valid) showAlert("Please review the highlighted fields.");
      return valid;
    }

    function setLoading(isLoading) {
      if (!button) return;
      var label = button.querySelector(".unisource-contact__submit-label");
      var loading = button.querySelector(".unisource-contact__submit-loading");
      button.disabled = isLoading;
      if (label) label.hidden = isLoading;
      if (loading) loading.hidden = !isLoading;
    }

    function buildClientSubmissionId() {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
      return "contact-" + Date.now() + "-" + Math.random().toString(36).slice(2);
    }

    function buildPayload() {
      return {
        formType: "contact",
        clientSubmissionId: form.dataset.clientSubmissionId || "",
        name: getValue("name"),
        organization: getValue("organization"),
        email: getValue("email"),
        phone: getValue("phone"),
        inquiryType: getValue("inquiryType"),
        preferredContactMethod: getPreferredContactMethod(),
        message: getValue("message"),
        consent: getConsentChecked(),
        companyWebsite: getValue("companyWebsite")
      };
    }

    async function submitForm(event) {
      event.preventDefault();
      event.stopPropagation();

      if (isSubmitting || form.dataset.submitting === "true") {
        console.warn("[Unisource Contact Form] Duplicate submit blocked.");
        return;
      }

      if (!validate()) return;

      form.dataset.clientSubmissionId =
        form.dataset.clientSubmissionId || buildClientSubmissionId();

      var payload = buildPayload();
      isSubmitting = true;
      form.dataset.submitting = "true";
      setLoading(true);
      clearErrors();

      try {
        var response = await fetch(submitUrl, {
          method: "POST",
          cache: "no-store",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        });

        var data = null;
        try { data = await response.json(); } catch (jsonError) { data = null; }

        if (!response.ok) {
          var serverMessage = data && (data.message || data.error)
            ? data.message || data.error
            : "We could not submit your message. Please try again.";
          throw new Error(serverMessage);
        }

        var referenceNumber = data && (
          data.reference || data.referenceNumber || data.submissionId || data.id
        );

        if (reference) reference.textContent = referenceNumber || "CNT-Submitted";
        form.hidden = true;

        if (success) {
          success.hidden = false;
          success.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } catch (error) {
        showAlert(error.message || "We could not submit your message. Please try again.");
        isSubmitting = false;
        form.dataset.submitting = "false";
        setLoading(false);
      }
    }

    function resetForm() {
      isSubmitting = false;
      form.dataset.submitting = "false";
      form.dataset.clientSubmissionId = "";
      setLoading(false);
      form.reset();
      clearErrors();
      if (count) count.textContent = "0";
      if (success) success.hidden = true;
      form.hidden = false;
      var emailRadio = form.querySelector('input[name="preferredContactMethod"][value="email"]');
      if (emailRadio) emailRadio.checked = true;
    }

    if (message && count) {
      count.textContent = String(message.value.length || 0);
      message.addEventListener("input", function () {
        count.textContent = String(message.value.length || 0);
      });
    }

    form.addEventListener("submit", submitForm);
    if (again) again.addEventListener("click", resetForm);
  });
})();